import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Text } from 'foundations-components/components/Text';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const DealTableEmptyState = () => /*#__PURE__*/_jsx(EmptyState, {
  "data-test-id": "no-results-message",
  titleText: /*#__PURE__*/_jsx(Text, {
    as: "h4",
    marginBlockEnd: "400",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkDealTable.emptyState.header"
    })
  }),
  primaryContent: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "frameworkDealTable.emptyState.body"
  }),
  secondaryContent: /*#__PURE__*/_jsx(Illustration, {
    name: "empty-state-charts",
    width: "100%"
  }),
  secondaryContentWidth: 150
});
export default DealTableEmptyState;